import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';

const URLS = {
  BASE: '/org/%s/email-templates/',
  INDIVIDUAL: '/org/%s/email-templates/%s/',
};

type TemplateValue = {
  name: string;
  subject: string;
  content: string;
  text_content: string;
  group: 'invitation' | 'reminder';
};
type OrganizatioName = string;

export default {
  getEmailTemplate: ({
    orgName,
    templateId,
  }: {
    orgName: OrganizatioName;
    templateId: number;
  }) =>
    apiInstance({
      method: 'GET',
      url: sprintf(URLS.INDIVIDUAL, orgName, templateId),
    }),
  getEmailTemplates: ({ orgName }: { orgName: OrganizatioName }) =>
    apiInstance({
      method: 'GET',
      url: sprintf(URLS.BASE, orgName),
    }),
  saveEmailTemplate: ({
    orgName,
    templateValue,
  }: {
    orgName: OrganizatioName;
    templateValue: TemplateValue;
  }) =>
    apiInstance({
      method: 'POST',
      url: sprintf(URLS.BASE, orgName),
      data: templateValue,
    }),
  deleteTemplate: ({
    orgName,
    templateId,
  }: {
    orgName: OrganizatioName;
    templateId: number;
  }) =>
    apiInstance({
      method: 'DELETE',
      url: sprintf(URLS.INDIVIDUAL, orgName, templateId),
    }),
  updateTemplate: ({
    orgName,
    templateId,
    templateValue,
  }: {
    orgName: OrganizatioName;
    templateId: number;
    templateValue: TemplateValue;
  }) =>
    apiInstance({
      method: 'PATCH',
      url: sprintf(URLS.INDIVIDUAL, orgName, templateId),
      data: templateValue,
    }),
};
